<template>
    <div class="action-table">
        <v-client-table
            :data="tableData"
            :columns="columns"
            :options="options"
            ref="table"
        >
            <colored-letter-square
                slot="cls_column"
                slot-scope="props"
                :name="props.row.name"
                :length="2"
                :color="squareColor(props.row.users_count)"
            >
            </colored-letter-square>
            <div
                slot="actions"
                slot-scope="props"
                :canAccessEmails="canAccessEmails"
                :canAccessCourses="canAccessCourses"
                :canMoveClients="canMoveClients"
            >
                <ClientTableActions
                    :data="props.row"
                    :index="props.index"
                    :canAccessEmails="canAccessEmails"
                    :canAccessCourses="canAccessCourses"
                    :canAccessWbtConfigs="canAccessWbtConfigs"
                    :canMoveClients="canMoveClients"
                ></ClientTableActions>
            </div>
        </v-client-table>
    </div>
</template>

<script>
import { Event } from 'vue-tables-2';
import { EventBus } from '../eventbus';
import Name from './partials/Name.vue';

export default {
    props: ['client'],

    data() {
        return {
            tableData: [],
            canAccessEmails: false,
            canAccessCourses: false,
            canAccessWbtConfigs: false,
            canMoveClients: false,
            columns: [
                'cls_column',
                'name',
                'users_count',
                'subclient_count',
                'actions',
            ],
            options: {
                headings: {
                    cls_column: '',
                    name: this.trans('clients.label.name'),
                    users_count: this.trans('clients.label.users_count'),
                    subclient_count: this.trans(
                        'clients.label.subclient_count'
                    ),
                    actions: this.trans('vuetables.label.actions'),
                },

                texts: {
                    count: this.trans('vuetables.label.countText'),
                    filter: this.trans('vuetables.label.filter'),
                    noResults: this.trans('vuetables.label.loading'),
                    filterPlaceholder: this.trans('vuetables.label.search'),
                },

                sortable: ['name', 'users_count', 'subclient_count'],

                filterable: ['name', 'subclient_name'],

                templates: {
                    name: Name,
                },
            },
        };
    },

    created() {
        this.fetch();
    },

    computed: {
        create_url() {
            if (this.client) {
                return this.route('tenant.clients.create.subclients', {
                    parentClient: this.client.id,
                });
            }
            return this.route('tenant.clients.create');
        },
    },

    methods: {
        fetch() {
            var url;
            if (this.client) {
                url = this.route('tenantapi.clients.subclients.index', {
                    client: this.client.id,
                });
            } else {
                url = this.route('tenantapi.clients.index');
            }

            axios.get(url).then(this.refresh);
        },

        refresh({ data }) {
            this.tableData = data.data;
            this.canAccessEmails = data.can_access_emails;
            this.canAccessCourses = data.can_access_courses;
            this.canAccessWbtConfigs = data.can_access_wbt_configs;
            this.canMoveClients = data.can_move_clients;
            this.canTransferCourse = data.can_transfer_course;

            // change the error text from 'now loding' to 'no match'
            this.options.texts.noResults = this.trans(
                'vuetables.label.noResults'
            );
        },

        squareColor(clientUserCount) {
            var userCountColorPartitions = {
                50: '#ee7f7b',
                100: '#e08585',
                500: '#d65c5c',
                1000: '#d02f2f',
            };
            var squareColor = '#b23434';

            for (var maxPartitionUserCount in userCountColorPartitions) {
                if (clientUserCount <= maxPartitionUserCount) {
                    squareColor =
                        userCountColorPartitions[maxPartitionUserCount];
                    break;
                }
            }

            return squareColor;
        },
    },

    mounted() {
        // Connect to selected tenant database
        EventBus.$on('databaseChanged', () => {
            this.fetch();
        });

        var filter = this.debounce(query => {
            this.$refs.table.setFilter(query);
        }, 500);

        EventBus.$on('onFilter', query => {
            filter(query);
        });

        EventBus.$on('onDelete', deleteId => {
            var index = this.tableData.findIndex(data => data.id == deleteId);
            this.tableData.splice(index, 1);
        });
    },
};
</script>
